import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { API } from "../../config";
import { isAuthenticated } from '../auth'
import AdminSidebar from './AdminSidebar'
import Pagination from "../../components/Pagination";
import { deleteMedia} from './apiIndex'

const AllMedias = () => {
    const [medialist, setMediaList] = useState([]);
    const [error, setError] = useState(false);
    const [success,setSuccess]=useState(false)

    const params = useParams()
    const pageNumber = params.pageNumber || 1;
    const [page, setPage] = useState(pageNumber);
    const [pages, setPages] = useState(1);
    const [pageSize, setPageSize] = useState('');
    const [total, setTotal] = useState('');

    const {token} =isAuthenticated()

    const start = (() => { 
        if(page>1)
            { 
                return (pageSize * (page -1))
            } 
            return 1; 
    })();

    const end = (() => { 
        if(page>1){ 
            if(page.toString()===pages){
                return total
            }
            return (pageSize + start)
        } 
        return pageSize; 
    })();

    const loadMediaList = async() => {
                    const res = await fetch(`${API}/api/allmedialist?page=${page}`);
                    if(res.ok) {
                            const { data, pages: totalPages, total, pageSize } = await res.json();
                            if (data.error) {
                                console.log(data.error)
                            } else {
                                setPageSize(pageSize);
                                setPages(totalPages);
                                setTotal(total);
                                setMediaList(data);
                            }
                        } else {
                                const res = await fetch(`${API}/api/allmedialist?page=${page-1}`);
                                if(res.ok) {
                                        const { data, pages: totalPages, total, pageSize } = await res.json();
                                        if (data.error) {
                                            console.log(data.error)
                                        } else {
                                            setPageSize(pageSize);
                                            setPage(page-1);
                                            setPages(totalPages);
                                            setTotal(total);
                                            setMediaList(data);
                                        }
                                } else {
                                       const res = await fetch(`${API}/api/medialist`);
                                        if(res.ok) {
                                             const { data } = await res.json();
                                             setMediaList(data);
                                        } else {
                                            setError('')
                                            setSuccess(false)
                                        }
                                }
                        }
    }
    
    useEffect(() => {
        loadMediaList()
    }, [page])


    const deleteHandler = (id) => {
        if (window.confirm('Are you sure')) {
            setError('')
            setSuccess(false)
            //make request to add category
            deleteMedia(token,`${id}`)
            .then(data=>{
                if(data.error){
                    setError(data.error)
                }
                else{
                    setError('')
                    setSuccess(true)
                    loadMediaList()
                }
            })
        }
      }
    // to show error msg
    const showError=()=>(
        <div className="alert alert-danger" style={{display:error?'':'none'}}>
            {error}
        </div>
    )

    //to show success msg
    const showSuccess=()=>(
        <div className="alert alert-info" style={{display:success?'':'none'}}>
       Success: You have modified Media!
    </div>
    )
    return (
        <>
            <div className="container dashboard-wrapper">
                <div className="row">
                    <div className="col-md-3">
                        <AdminSidebar />
                    </div>
                    <div className="col-md-9 adminpage-container">
                        {showError()}
                        {showSuccess()}
                        <div className="headerwrap">
                        <Link to="/admin/addmedia" className="btn btn-primary">Add Media</Link>
                        <h6 className="text-center text-muted m-3 pull-right">
                            Showing {start} to {end} of {total} ({pages} Pages)
                        </h6>
                        </div>
                        <hr />
                        <div className="table-responsive">
                        <table className="table table-bordered table-secondary">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th style={{width: '33%'}}>Description</th>
                                    <th>Image</th>
                                    <th>Type</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {medialist && medialist.length>0 ? (
                             <tbody>
                                {medialist.map((item, i) => (
                                    <tr key={i}>
                                        <td>{item.media_name}</td>
                                        <td>{item.media_description}</td>
                                        <td>
                                         {item.media_image ? (
                                        <>
                                        <img src={`${API}/${item.media_image}`} alt={item.media_name} className="img-fluid" width="130" />
                                        </>
                                        ) : (<img src={`${API}/public/uploads/default-placeholder.png`} alt={item.media_name} className="img-fluid" width="130" />)}
                                        </td>
                                        <td>
                                        {(() => {
                                            if (item.media_isGallery===1 && item.media_isSlider===1) {
                                              return (
                                                <>Slider, Gallery</>
                                              )
                                            } else if (item.media_isSlider===1) {
                                              return (
                                                <>Slider</>
                                              )
                                            } else if (item.media_isGallery===1) {
                                              return (
                                                <>Gallery</>
                                              )
                                            } else {
                                              return ('')
                                            }
                                          })()}
                                        </td>
                                        <td>
                                            <Link to={`/admin/editmedia/${item._id}`} className="btn btn-warning">
                                                Update
                                            </Link>
                                            <Link to="/admin/allmedia" className="btn btn-danger" onClick={() => deleteHandler(item._id)}>
                                                Delete
                                            </Link>

                                        </td>

                                    </tr>
                               ))}
                            </tbody>
                            ) : (
                               <tbody>
                                    <tr><td colSpan={5} style={{textAlign:"center"}}>No results!</td></tr>
                                 </tbody>
                            )}
                        </table>
                        </div>
                        <Pagination page={page} pages={pages} changePage={setPage} />
                    </div>
                </div>
            </div>

        </>
    )
}

export default AllMedias
